import { useCallback, useRef, useState } from "react";
import { useMount, useUnmount, useUpdateEffect } from "react-use";

export const useResolver = (callback, update = false) => {
  const ref = useRef();
  const [state, setState] = useState({ loading: true, error: null });

  const handler = useCallback(() => {
    ref.current = new AbortController();
    const { signal } = ref.current;

    const call = async () => {
      await callback(signal);
    };

    call()
      .then(() => {
        setState({ loading: false, error: null });
      })
      .catch((e) => {
        if (e.name === "AbortError") {
          return;
        }

        setState({ loading: false, error: e });
      });
  }, [callback]);

  useMount(handler);

  useUpdateEffect(() => {
    if (update) {
      setState({ loading: true, error: null });
      handler();
    }
  }, [update, handler]);

  useUnmount(() => {
    ref.current.abort();
  });

  return state;
};
